import { AlertCircle } from "lucide-react";
import { turnAnchorId } from "./useAnchoredScroll";
import type { RunError } from "./useRunError";

interface RunErrorNoticeProps {
  error: RunError;
}

// Why the last response stopped, shown above the composer. Sits at
// conversation level rather than on the turn because a failed run persists
// nothing, so the turn itself may be gone by the time this renders.
export const RunErrorNotice = ({ error }: RunErrorNoticeProps) => {
  const reference = turnAnchorId(error.runId);
  return (
    <div
      className="mx-auto mb-2 flex max-w-[60rem] items-start gap-2.5 px-2"
      role="status"
      aria-live="polite"
    >
      <AlertCircle className="mt-0.5 size-4 shrink-0 text-muted-foreground" aria-hidden />
      <div className="flex min-w-0 flex-col gap-0.5">
        <p className="text-sm leading-relaxed text-foreground/80">{error.message}</p>
        {reference && (
          <p className="text-xs text-muted-foreground">
            Reference <code className="break-all font-mono">{reference}</code>
          </p>
        )}
      </div>
    </div>
  );
};
